import React from 'react';
import { getTranscodedUrl } from 'es6/services/image-manager';

export const ContentFigureSizes = {
  SMALL: {
    width: 140,
    height: 140,
    size: 'small',
  },

  MEDIUM: {
    width: 200,
    height: 200,
    size: 'medium',
  },

  LARGE: {
    width: 260,
    height: 260,
    size: 'large',
  },
};

export function ContentFigure({ size, imgSrc }) {
  let style;

  if (imgSrc) {
    style = { backgroundImage: `url('${getTranscodedUrl(imgSrc, size)}')` };
  }

  return (
    <div className="content-column course-accent">
      <figure
        className="content-figure"
        data-size={size.size}
        style={style}
      />
    </div>
  );
}

ContentFigure.propTypes = {
  size: React.PropTypes.oneOf(_.values(ContentFigureSizes)).isRequired,
  imgSrc: React.PropTypes.string,
};

export default ContentFigure;
